$(function (){

  $('.yt-reviews').on('click', function(){
    
    if ( $('.product-video').hasClass('slick-initialized')) {    
    }
    
    else {
    $('.product-video').slick({
      dots: true,
      prevArrow: false,
      nextArrow: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
      
    }
    
    $('.product-images').addClass('hide');
    $('.product-images-indicator').addClass('hide');
    $('.yt-reviews-container').addClass('hide');
    $('.product-video').removeClass('hide');
    $('.thumbnails-arrows').addClass('hide');

    $('.product-images-container').addClass('video-css');
    
    $('.product-options').on('click', function(){
    $('.product-images').removeClass('hide');
    $('.product-video').addClass('hide');
    $('.product-images-indicator').removeClass('hide');
    $('.thumbnails-arrows').removeClass('hide')

    $('.product-images-container').removeClass('video-css');
    $('.yt-reviews-container').removeClass('hide');



    });

  });

});  



var video_wrapper = $('.youtube-video-place');
//  Check to see if youtube wrapper exists

if(video_wrapper.length){
// If user clicks on the video wrapper load the video.
$('.play-youtube-video').on('click', function(){ //change selector class
  var plop = $(this).data('yt-url');
  var vidIndex = $(this).data('video-index');
   
  $("#youtube-video-"+ vidIndex +"").html('<iframe allowfullscreen frameborder="0" style="width:100%; height:100%"; class="embed-responsive-item" src="' + plop + '"></iframe>');

 
});
  
  $('.video-button').on('click', function(){ //change selector class
  
   var videoId = $(this).data('video-url');
  $(".product-video-info").html('<iframe width="560" height="315" src="https://www.youtube.com/embed/'+ videoId +'?rel=0&showinfo=0&autoplay=1"  frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

 
});
  
}

if ($('.page-product-custom')) {
  /*
  $('.product-thumbnails').each(function(e) {
    var color = $(this).attr('data-color');
    $('.thumbnails-'+color).slick({
      slidesToShow: 6,
      slidesToScroll: 6,
      vertical: true,
      asNavFor: '.gallery-'+color,
      dots: false,
      focusOnSelect: true,
      verticalSwiping: true,
      responsive: [
        {
            breakpoint: 1023,
            settings: {
              vertical: false,
               slidesToShow: 4,
              slidesToScroll: 2,
              verticalSwiping:false
            }
        }
      ]
    });
  });
  
  $('[data-option="Color"] .product-form-option').on('click', function(){
    var color = $(this).val();
    $('.product-thumbnails').attr('data-active', false);
    $('.thumbnails-'+color).attr('data-active', true);
  });
  */

  $('.product-thumbnails').slick({
      slidesToShow: 8,
      slidesToScroll: 8,
      vertical: true,
      asNavFor: '.product-gallery',
      dots: false,
      focusOnSelect: true,
      verticalSwiping: true,
      infinite: false,
      responsive: [
        {
            breakpoint: 1023,
            settings: {
              vertical: false,
               slidesToShow: 5,
              slidesToScroll: 2,
              verticalSwiping:false
            }
        }
      ]
    });

  $('.moreless-button').click(function(e) {
    e.preventDefault();
    $('.product-description').toggleClass('show');
    if ($('.moreless-button').text() == "READ MORE") {
      $(this).text("READ LESS");
    } else {
      $(this).text("READ MORE");
    }
  });

  $('.faq-tab-content').on('click', function(){
    $(this).toggleClass('is-open');
    if ($(this).hasClass('is-open')) {
      $(this).find('.faq-tab-content-question span').text('-');
    } else {
      $(this).find('.faq-tab-content-question span').text('+');
    }  
  });

  $('#goes-with-add').on('click', function(){
    $(this).addClass('added').delay(3000).queue(function( next ){
        $(this).removeClass('added'); 
        next();
    });
  });

  $('#quantity-decrease').on('click', function(){
    var qty = $('#quantity-value').text();
    if (parseInt(qty) > 1) {
      $('#quantity-value').text(parseInt(qty)-1);
      $('#add-to-cart').attr('data-cart-quantity', parseInt(qty)-1);
    }
  });

  $('#quantity-increase').on('click', function(){
    var qty = $('#quantity-value').text();
    $('#quantity-value').text(parseInt(qty)+1);
    $('#add-to-cart').attr('data-cart-quantity', parseInt(qty)+1);
  });

  $('#size-chart-open').on('click', function(e){
    e.preventDefault();
    $('.size-chart-modal').addClass('open');
    $('body').addClass('no-scroll');
  });  

  $('#modal-close').on('click', function(e){
    e.preventDefault();
    $('.size-chart-modal').removeClass('open');
    $('body').removeClass('no-scroll');
  });  
  
}

if ($('.page-product-custom-new')) {
  $('.product-thumbnails-new').each(function(e) {
    var color = $(this).attr('data-color');
    $(this).slick({
      slidesToShow: 6,
      slidesToScroll: 3,
      asNavFor: '.product-images[data-color="'+color+'"]',
      dots: false,
      focusOnSelect: true
    });
  });

  // $(window).on('resize orientationChange', function(event) { 
  //   $('.product-thumbnails-new').each(function(e) {
  //     var color = $(this).attr('data-color');
  //     $(this).slick('reinit'); 
  //   });
  // });
  
  $('[data-option="Color"] .product-form-option').on('click', function(){
    var color = $(this).val();
    $('.thumbnails-arrows').attr('data-active', false);

    if($('.thumbnails-arrows[data-color="'+color+'"]').attr("data-upgrade")) {
      var upgrade = $('[data-option="TacSac Upgrade"] input[type="radio"]:checked').val();
      $('.thumbnails-arrows[data-color="'+color+'"][data-upgrade="'+upgrade+'"]').attr('data-active', true);
      $('.product-thumbnails-new[data-color="'+color+'"][data-upgrade="'+upgrade+'"]').slick('reinit');
    } else {
      $('.thumbnails-arrows[data-color="'+color+'"]').attr('data-active', true);
      $('.product-thumbnails-new[data-color="'+color+'"]').slick('reinit');
    }
  });

  $('[data-option="TacSac Upgrade"] .product-form-option').on('click', function(){
    var upgrade = $(this).val();
    var color = $('[data-option="Color"] input[type="radio"]:checked').val();
    $('.thumbnails-arrows').attr('data-active', false);

    $('.thumbnails-arrows[data-color="'+color+'"][data-upgrade="'+upgrade+'"]').attr('data-active', true);
    $('.product-thumbnails-new[data-color="'+color+'"][data-upgrade="'+upgrade+'"]').slick('reinit');
  });
}


  

